<template>
  <SimpleModuleDashboard
    :module-id="Modules.PHP"
    :profile-id="Profiles.PERSONAL"
    include-php-custom
    :actions="actions"
    :widget-filter="filterWidgets"
  />
</template>

<script>
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'

export default {
  components: { SimpleModuleDashboard },
  data: () => ({
    Modules,
    Profiles,
    actions: [
      { id: 'crudPHPInterfaces', reference: 'crudPHPInterfaces', route: 'PHPStaffCrudPHPInterfaces', tone: 'primary' },
      { id: 'crudPHPCron', reference: 'crudPHPCron', route: 'PHPStaffCrudPHPCron', tone: 'secondary' },
      { id: 'crudPHPCallback', reference: 'crudPHPCallback', route: 'PHPStaffCrudPHPCallback', tone: 'warning' },
    ],
  }),
  methods: {
    filterWidgets(widget) {
      return !widget.php_id && !widget.external_url && !widget.height
    },
  },
}
</script>
